import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { readPersistedSessionIds } from '../../../services/kronosPrefs/sessionIds';
import { readUserPrefString, writeUserPrefString } from '../../../services/kronosPrefs/userPrefs';

/**
 * Opens the global command palette; shared by TopBar (desktop) and Nav (mobile chrome).
 */
export default function CommandPaletteSearchTrigger({ className = '' }) {
    const { user } = useSelector(state => state.auth);
    const { KUserSettings } = useSelector(state => state.userSettings);
    const { t } = useTranslation();
    const search_btn_class = KUserSettings?.darkTheme ? 'text-white' : 'text-dark';
    const [command_palette_glow, set_command_palette_glow] = useState(false);

    useEffect(() => {
        try {
            const { userId } = readPersistedSessionIds();
            const used = userId && readUserPrefString(userId, 'commandPaletteUsed') === '1';
            if (used) {
                return;
            }
            set_command_palette_glow(true);
            const timer = window.setTimeout(() => set_command_palette_glow(false), 30000);
            return () => window.clearTimeout(timer);
        } catch (_err) {
            set_command_palette_glow(true);
            const timer = window.setTimeout(() => set_command_palette_glow(false), 30000);
            return () => window.clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        const on_palette_open = () => {
            try {
                const { userId } = readPersistedSessionIds();
                if (!userId) {
                    return;
                }
                if (readUserPrefString(userId, 'commandPaletteUsed') === '1') {
                    return;
                }
                writeUserPrefString(userId, 'commandPaletteUsed', '1');
            } catch (_err) {
                // ignore
            }
            set_command_palette_glow(false);
        };
        window.addEventListener('kronos.command_palette.open', on_palette_open);
        return () => window.removeEventListener('kronos.command_palette.open', on_palette_open);
    }, []);

    if (!user) {
        return null;
    }

    return (
        <button
            type="button"
            className={`btn btn-link ${search_btn_class} px-2 topbar-search-btn ${command_palette_glow ? 'topbar-search-btn--glow' : ''} ${className}`.trim()}
            onClick={() => window.dispatchEvent(new Event('kronos.command_palette.open'))}
            title={t('common.open_search_bar')}
        >
            <i className="fa fa-search"></i>
        </button>
    );
}
